/**
 * 全局常量配置
 * 使用构建时注入的 OEM 配置，无需运行时域名判断
 */

// 从构建时注入的环境变量获取 OEM 配置
// 这些值在构建时由 vite.config.ts 根据 OEM_NAME 注入
const getOemConfig = () => {
    // 调试：输出环境变量值（已移除控制台输出）
  
  return {
    appName: import.meta.env.VITE_OEM_PLATFORM_NAME || '山海智影引擎',
    logo: import.meta.env.VITE_OEM_LOGO || '/img/shanhai2_logo.png',
    copyright: import.meta.env.VITE_OEM_COPYRIGHT || '2025.山海智影引擎 AI短剧翻译配音平台',
    appDescription: import.meta.env.VITE_OEM_APP_DESCRIPTION || 'AI短剧翻译配音平台',
  };
};

const oemConfig = getOemConfig();

// 应用名称（从 OEM 配置获取）
export const APP_NAME = oemConfig.appName;

// 应用完整描述（从 OEM 配置获取）
export const APP_DESCRIPTION = oemConfig.appDescription;

// 版权信息（从 OEM 配置获取）
export const COPYRIGHT_TEXT = oemConfig.copyright;

// Logo图片地址（从 OEM 配置获取）
export const SHANHAI_LOGO = oemConfig.logo;

